import React, { Component } from "react";
import { Form } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import { UserInput, PasswordInput } from "../../components";

class LEFConfiguration extends Component {
  handleInputChange = e => {
    let { dealer, handleChange } = this.props;

    if (Object.keys(dealer).length === 0) return;

    handleChange({ ...dealer, [e.target.name]: e.target.value });
  };

  render() {
    const { dealer, t } = this.props;

    return (
      <Form>
        <Form.Field className="full-width-input">
          <label>{t("username").message || "Username"}</label>
          <UserInput value={dealer.lef_username} name="lef_username" placeholder={t("username").message || "Username"} onChange={this.handleInputChange} />
        </Form.Field>

        <Form.Field className="full-width-input">
          <label>{t("password").message || "Password"}</label>
          <PasswordInput
            value={dealer.lef_password}
            showAsteriskPlaceholder={dealer.has_lef_password}
            name="lef_password"
            placeholder={t("password").message || "Password"}
            onChange={this.handleInputChange}
          />
        </Form.Field>
      </Form>
    );
  }
}

export default withTranslation()(LEFConfiguration);
